module.exports = __webpack_public_path__ + "assets/img/portfolio-ketvirtas.d5209e4e.jpg";